import React, { useState } from "react";
import "../Home/Home.css";
import Box from "@mui/material/Box";
import Card from "../../components/Elements/Card/Card";
import Typography from "@mui/material/Typography";
import Input from "../../components/Elements/Input/Input";
import Dropdown from "../../components/Elements/Dropdown/Dropdown";
import ButtonComponent from "../../components/Elements/Button/Button";
import FileUploadForm from "../../components/Elements/ResumeUplode/ResumeUplode";
import { useTranslation } from "react-i18next";
import { useFormik } from "formik";
import Grid from "@mui/material/Grid";
import { EMAIL_REGEX, PHONE_REGEX, SHEET_API_URL } from "../../utils/Regex";
import axios from "axios";
import "./Application.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Icon from "../../components/Elements/Icon/Icon";
import Images from "../../constant/images";
import { CircularProgress } from "@mui/material";

const Application = () => {
  const { t } = useTranslation();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [selectedFile, setSelectedFile] = useState<any>(null);
  // const [uploadResult, setUploadResult] = useState<string | null>(null);

  console.log("selectedFile", selectedFile);
  const experienceOptions = [
    { label: "Fresher", value: "0" },
    { label: "0-1 Years", value: "0-1" },
    { label: "1-3 Years", value: "1-3" },
    { label: "3-5 Years", value: "3-5" },
    { label: "5-10 Years", value: "5-10" },
    { label: "10+ Years", value: "10_plus" },
  ];
  const designations = [
    { label: "Software Engineer", value: "software_engineer" },
    { label: "Senior Developer", value: "seniordeveloper" },
    { label: "Team Lead", value: "teamlead" },
    { label: "Project Manager", value: "projectmanager" },
    { label: "CTO", value: "cto" },
    { label: "Other", value: "other" },
  ];

  const nationalities = [
    { label: "Indian", value: "indian" },
    { label: "American", value: "american" },
    { label: "Canadian", value: "canadian" },
    { label: "British", value: "british" },
    { label: "Other", value: "other" },
  ];
  
  const industries = [
    { label: "Information Technology", value: "it" },
    { label: "Healthcare", value: "healthcare" },
    { label: "Finance", value: "finance" },
    { label: "Education", value: "education" },
    { label: "Retail", value: "retail" },
    { label: "Manufacturing", value: "manufacturing" },
    { label: "Real Estate", value: "realestate" },
    { label: "Other", value: "other" },
  ];
  
 
  const formFields = [
    {
      label: t("contacts.fullName"),
      placeholder: t("contacts.fullName"),
      name: "fullName",
      isDropdown: false,
    
    },
    {
      label: t("contacts.email"),
      placeholder: t("contacts.email"),
      name: "email",
      isDropdown: false,
    },
    {
      label: t("contacts.phone"),
      placeholder: t("contacts.phone"),
      name: "phone",
      isDropdown: false,
    },
    {
      label: "Experience",
      placeholder: "Select Experience",
      name: "experience",
      isDropdown: true,
    },
    {
      label: "Nationality*",
      placeholder: "Select Nationality",
      name: "nationality",
      isDropdown: true,
    },
    {
      label: "Current Designation",
      placeholder: "Select Destination",
      name: "currentdesignation",
      isDropdown: true,
    },
  ];

  const validate = (values: any) => {
    const errors: any = {};

if (!values.fullName.trimStart()) {
  errors.fullName = "Full Name is required";
} else if (!/^[A-Za-z\s]+$/.test(values.fullName.trimStart())) {
  errors.fullName = "Only letters and spaces are allowed";
}
    if (!values.email) errors.email = "Email is required";
    else if (!EMAIL_REGEX.test(values.email))
      errors.email = "Invalid email address";

    if (!values.phone) errors.phone = "Phone number is required";
    else if (!PHONE_REGEX.test(values.phone))
      errors.phone = "Contact number must be 10 digits";

    if (!values.Industry) errors.Industry = "Industry is required";

    if (!values.experience) errors.experience = "Experience is required";
    if (!values.nationality) errors.nationality = "nationality is required";
    if (!values.currentdesignation) errors.currentdesignation = "currentdesignation is required";

    // if (!values.message) errors.message = "Message is required";

    if (!values.resume) errors.resume = "Resume is required";

    return errors;
  };
  const uploadResumeAndGetURL = async (file: File | null): Promise<string | null> => {
    if (!file) return null;
  
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
  
      reader.onloadend = async () => {
        if (typeof reader.result === "string") {
          const base64 = reader.result.split(",")[1];
          const formData = new FormData();
          formData.append("base64", base64);
          formData.append("filename", file.name);
          formData.append("mimeType", file.type);
  
          try {
            const response = await axios.post(
              `${SHEET_API_URL}?action=doPostResume`,
              formData
            );
            if (response.data.success) {
              resolve(response.data.url); // ✅ return the URL
            } else {
              reject("Upload failed: " + response.data.error);
            }
          } catch (error) {
            reject("Upload failed: " + error);
          }
        } else {
          reject("Error: File reading failed.");
        }
      };
  
      reader.readAsDataURL(file);
    });
  };

  const formik = useFormik({
    initialValues: {
      fullName: "",
      email: "",
      phone: "",
      experience: "",
      Industry: "",
      nationality:"",
      currentdesignation:"",
      // message: "",
      resume: "", // ✅ URL store karne ke liye
    },
    validate,
    onSubmit: async (values,{resetForm}) => {
      setIsSubmitting(true);
    
      try {
        // ✅ Upload and wait for the resume URL
        const resumeUrl = await uploadResumeAndGetURL(selectedFile);
    
        if (!resumeUrl || typeof resumeUrl !== "string") {
          toast.error("Resume upload failed.");
          setIsSubmitting(false);
          return;
        }
    
        const payload = {
          fullName: values.fullName,
          emailId: values.email,
          phoneNumber: values.phone,
          experience: values.experience,
          nationality:values.nationality,
          message:"",
          designation:values.currentdesignation,
          industry:values.Industry,
          resume: resumeUrl, // ✅ Use the uploaded URL
        };
    
        const response = await axios.post(
          `${SHEET_API_URL}?action=doPostDrop`,
          JSON.stringify(payload)
        );
    
        if (response.data.success) {
          toast.success(
            "We’ve received your application and we’ll forward for suitable job opportunities."
          );
          resetForm(); // 👈 Reset the form here

        } else {
          toast.error("Something went wrong. Please try again.");
        }
      } catch (error) {
        console.error("Error submitting form:", error);
        toast.error("Error submitting form. Please check console.");
      } finally {
        setIsSubmitting(false);
      }
    },
    
  });

  return (
    <>
      <ToastContainer position="top-center" autoClose={4000} />

      <Box className="apllication-main">
        <Typography className="apllication-heading">
          {/* {t("contacts.contactUs")} */}
          Find Your Dream Job Now
        </Typography>
        <Typography className="apllication-heading2">
          1.5lakh + job opportunities to explore
        </Typography>
      </Box>
      {/*  */}

      <Box className="apllication-container">
        <Card className="apllication-card">
          <Box padding={" 30px"}>
            {/* <Box className="apllication-card-small" mb={2.5}></Box> */}
            <Typography className="apllication-card-heading" mb={1}>
              {/* {t("home.Trust")} */}
              Full-time
            </Typography>
            <Typography className="apllication-card2-heading">
              {/* {t("home.Ensuring")} */}
              Exciting full-time opportunities that allow you to enjoy
              lucrative  salary, benefits, and opportunities for growth and
              development.
            </Typography>
          </Box>
        </Card>
        <Card
          className="apllication-card"
          style={{ background: "#721372", marginTop: "-45px" }}
        >
          <Box padding={" 30px"}>
            {/* <Box className="apllication-card-small" mb={2.5}></Box> */}
            <Typography
              className="apllication-card-heading"
              color="white !important"
              mb={1}
            >
              {/* {t("home.Trust")} */}
              Remote{" "}
            </Typography>
            <Typography
              className="apllication-card2-heading"
              color="white !important"
            >
              {/* {t("home.Ensuring")} */}
              Lead your career with remote opportunities that offers competitive
              salary, benefits, and opportunities for growth.
            </Typography>
          </Box>
        </Card>

        <Card className="apllication-card">
          <Box padding={" 30px"}>
            {/* <Box className="service-card-small" mb={2}></Box> */}
            <Typography className="apllication-card-heading" mb={1}>
              {/* {t("home.Trust")} */}
              Data Science{" "}
            </Typography>
            <Typography className="apllication-card2-heading">
              {/* {t("home.Ensuring")} */}
              As a Data Scientist, analyze complex data, build predictive
              models, and drive business growth with your insights.
            </Typography>
          </Box>
        </Card>
        <Card className="apllication-card">
          <Box padding={"30px"}>
            {/* <Box className="apllication-card-small" mb={2}></Box> */}
            <Typography className="apllication-card-heading" mb={1}>
              {/* {t("home.Trust")} */}
              Engineering{" "}
            </Typography>
            <Typography className="apllication-card2-heading">
              {/* {t("home.Ensuring")} */}
              Design, develop, and innovate with the leading companies to work
              on cutting-edge projects and technologies.
            </Typography>
          </Box>
        </Card>
        <Card className="apllication-card" style={{ marginTop: "-35px" }}>
          <Box padding={" 30px"}>
            {/* <Box className="apllication-card-small" mb={2}></Box> */}
            <Typography className="apllication-card-heading" mb={1}>
              {/* {t("home.Trust")} */}
              Finance{" "}
            </Typography>
            <Typography className="apllication-card2-heading">
              {/* {t("home.Ensuring")} */}
              Drive business growth with your financial expertise! Take a
              leap and lead strategic financial initiatives.
            </Typography>
          </Box>
        </Card>
        <Card className="apllication-card">
          <Box padding={"30px 30px"}>
            {/* <Box className="apllication-card-small" mb={2}></Box> */}
            <Typography className="apllication-card-heading" mb={1}>
              {/* {t("home.Trust")} */}
              HR & Admin{" "}
            </Typography>
            <Typography className="apllication-card2-heading">
              {/* {t("home.Ensuring")} */}
              Support dynamic organizations with recruitment, talent management,
              and administrative expertise.
            </Typography>
          </Box>
        </Card>
        <Card className="apllication-card">
          <Box padding={"30px"}>
            {/* <Box className="apllication-card-small" mb={2}></Box> */}
            <Typography className="apllication-card-heading" mb={1}>
              {/* {t("home.Trust")} */}
              Marketing{" "}
            </Typography>
            <Typography className="apllication-card2-heading">
              {/* {t("home.Ensuring")} */}
              As a Marketing Specialist develop and execute innovative campaigns
              that drive brand awareness and growth.
            </Typography>
          </Box>
        </Card>
        <Card className="apllication-card" style={{ marginTop: "-35px" }}>
          <Box padding={" 30px"}>
            {/* <Box className="apllication-card-small" mb={2}></Box> */}
            <Typography className="apllication-card-heading" mb={1}>
              {/* {t("home.Trust")} */}
              Supply Chain{" "}
            </Typography>
            <Typography className="apllication-card2-heading">
              {/* {t("home.Ensuring")} */}
              Drive efficiency and lead procurement, inventory management, and
              distribution operations for leading organizations.
            </Typography>
          </Box>
        </Card>
        <Card className="apllication-card">
          <Box padding={" 30px"}>
            {/* <Box className="apllication-card-small" mb={2}></Box> */}
            <Typography className="apllication-card-heading" mb={1}>
              {/* {t("home.Trust")} */}
              Project Management{" "}
            </Typography>
            <Typography className="apllication-card2-heading">
              {/* {t("home.Ensuring")} */}
              Lead projects to success by planning, executing, and ensuring
              timely, budget-oriented results.
            </Typography>
          </Box>
        </Card>
      </Box>

      {/*  */}
      <Box className="Opportunities">
        <Typography className="apllication-left-text-mobile">
          Job Opportunities In The 
        </Typography>
        <Typography className="apllication-left-text-mobile" mb={3}>
          Organizations Of Your Choice
        </Typography>
        <Box className="Opportunities-container">
          {" "}
          <Icon src={Images.apllication} alt={""}></Icon>
        </Box>
        <Box className="Opportunities-container2">
          <Typography className="apllication-left-text">
            Job Opportunities In The Organizations Of Your Choice
          </Typography>
          <Box mt={4} display={"flex"} flexDirection={"column"} gap={"20px"}>
            <Box className="application-highlighted-text">
              <Typography className="highlighted-text-h1">
                Fortune 500 Companies
              </Typography>
              <Typography className="highlighted-text-body">
                Build an outstanding career with Fortune 500 companies
                offering a wide range of job opportunities in fields like
                technology, healthcare, finance, and more.
                {/* {t("hrSolution.section1")} */}
              </Typography>
            </Box>
            <Box className="application-highlighted-text">
              <Typography className="highlighted-text-h1">MNCs</Typography>
              <Typography className="highlighted-text-body">
                Explore exciting job opportunities in top MNC companies that
                offer early career opportunities with numerous job openings
                across different locations. {/* {t("hrSolution.section1")} */}
              </Typography>
            </Box>
            <Box className="application-highlighted-text">
              <Typography className="highlighted-text-h1">Startups</Typography>
              <Typography className="highlighted-text-body">
                Startups are holy places of work where you get to learn, work,
                explore, and experiment. Join them today to create a passionate
                career for you. {/* {t("hrSolution.section1")} */}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
      {/*  */}
      <Box className="form-container">
        <Box
          bgcolor={"#741374"}
          padding={"20px"}
          mt={5}
          boxShadow={"0px 0px 20px 0px #00000040;"}
        ></Box>
        <Card className={"form-card"}>
          <Typography variant="h6" className="pp">
            {t("application.dropResume")}
          </Typography>
          <form
            className="formStyle"
            onSubmit={(e) => {
              e.preventDefault();
              console.log("🔵 Form onSubmit triggered");
              console.log("⚠️ Form errors:", formik.errors); // ✅ Check if there are errors
              formik.handleSubmit();
            }}
          >
            <Box className="form-input-container">
              <Grid container spacing={4} justifyContent="space-between">
                {formFields.map((input, index) => (
                  <Grid item xs={12} sm={12} md={6} key={index}>
                    {/* <label htmlFor={input.name} style={{ display: "block", marginBottom: "8px" }}>
                    {input.label}
                  </label> */}
                    {input.isDropdown ? (
                      <Dropdown
                      className="Login"
                      placeholder={input.placeholder}
                        name={input.name}
                        id={input.name}
                        label={
                          input.label
                        }
                        options={
                          input.name === "experience"
                            ? experienceOptions
                            : input.name === "nationality"
                            ? nationalities
                            : designations // default fallback
                        }                     
                        onHandleChange={(value: string) => {
                          formik.setFieldValue(input.name, value);
                          // formik.setTouched({ ...formik.touched, [input.name]: true });
                        }}
                        value={(formik as any).values[input.name]}
                        error={
                          (formik as any).errors[input.name] &&
                          (formik as any).touched[input.name]
                            ? (formik as any).errors[input.name]
                            : ""
                        }
                        onBlur={formik.handleBlur}
                        touched={(formik as any).touched[input.name]}
                      />
                    ) : (
                      <Input
                        className="Login"
                        label={input.label}
                        placeholder={input.placeholder}
                        name={input.name}
                        id={input.name}
                        value={(formik as any)?.values[input.name]}
                        onChange={formik.handleChange}
                        error={
                          (formik as any).errors[input.name] &&
                          (formik as any).touched[input.name]
                            ? (formik as any).errors[input.name]
                            : ""
                        }
                        onBlur={formik.handleBlur}
                        touched={(formik as any).touched[input.name]}
                      />
                    )}
                  </Grid>
                ))}
                <Grid item xs={12} width={"100%"}>
                  <Dropdown
                      className="Login"
                      // placeholder={t("contacts.nationality")}
                    placeholder="Select Industry"
                    name="Industry"
                    id="Industry"
                    label={"                        Industry"
                      // <>
                      //   {/* {t("contacts.nationality")}{" "} */}
                      //   Industry
                      //   {/* <span style={{ color: "#000" }}>*</span> */}
                      // </>
                    }
                    options={industries}
                    // onHandleChange={(event: any) => {
                    //   formik.setFieldValue("Industry", event.target.value);
                    //   formik.setTouched({
                    //     ...formik.touched,
                    //     Industry: true,
                    //   });
                    // }}
                    onHandleChange={(value: string) => {
                      formik.setFieldValue("Industry", value);
                      // formik.setTouched({ ...formik.touched, [input.name]: true });
                    }}
                    value={formik.values.Industry}
                    error={
                      formik.errors.Industry && formik.touched.Industry
                        ? formik.errors.Industry
                        : ""
                    }
                    onBlur={formik.handleBlur}
                    touched={formik.touched.Industry}
                  />
                </Grid>

                {/*  */}

                <Grid item xs={12}>
                  {/* File Upload with Validation */}
                  {/* <FileUploadForm setSelectedFile={setSelectedFile} /> */}
                  <FileUploadForm
                    setSelectedFile={setSelectedFile}
                    setFieldValue={formik.setFieldValue} // ✅ Pass Formik function
                  />

                  {(formik as any)?.errors.resume && (
                    <Typography color="error" variant="body2">
                      {(formik as any)?.errors.resume}
                    </Typography>
                  )}
                </Grid>
                <Grid item xs={12}>
                  <ButtonComponent
                    type="submit" // ✅ Ensure this is set
                    className={"HireButton"}
                    disable={isSubmitting}
                    style={{
                      background: "#741374",
                      color: "white",
                      width: "130px !important",
                      height: "48px !important",
                      fontSize: "18px !important",
                    }}
                  >
                    {isSubmitting ? (
                      <CircularProgress size={20} color="inherit" />
                    ) : (
                      "Apply"
                    )}

                    {/* {t("application.apply")} */}
                  </ButtonComponent>
                </Grid>
              </Grid>
            </Box>
          </form>
        </Card>
      </Box>
    </>
  );
};
export default Application;
